<cl-common-error
  [statusCode]="404"
  (backButtonClicked)="handleBackButtonClicked()"
></cl-common-error>
